module.exports = __webpack_public_path__ + "img/dw_3.aad8f878.png";